import React from 'react'
import styles from './index.module.css'
import { Link } from '../Link'

export default function ReadMoreButton({
  children = null,
  url = '#',
  onClick = null,
  className = '',
}: {
  children?: React.ReactNode
  url?: string
  onClick?: (e: React.MouseEvent) => void
  className?: string
}) {
  const internalOnClick = (e) => {
    if (!onClick) return
    e?.preventDefault()
    return onClick(e)
  }
  children = children ?? 'Read more...'

  return (
    <Link reloadDocument to={url} className={`${styles.btnReadMore} ${className}`} onClick={internalOnClick}>
      {children}
    </Link>
  )
}
